module.exports = __webpack_public_path__ + "img/turbo-features8.3341387d.png";